angular.module('ikeweb.folders').controller('FolderController', ['$scope', 'folderService', 'events', 'confirmationService', 'orderByFilter', '$translate',
    function($scope, folderService, EVENTS, confirmationService, orderByFilter, $translate) {

        function select(folder) {
            folderService.setCurrent(folder);
            $scope.selected = folder;
            $scope.$emit(EVENTS.FOLDER.SELECTED, folder);
        }

        function firstIfExist(folders) {
            return folders.length ?
                folders[0] :
                undefined;
        }

        function isSame(folder) {
            return function(anotherFolder) {
                return folder && anotherFolder && folder.getId() === anotherFolder.getId();
            };
        }

        function sameName(name) {
            return function(folder) {
                return folder.getName() === name;
            };
        }

        function folderNameExists(name) {
            return $scope.folders.filter(sameName(name)).length > 0;
        }

        function folderExistsIn(folder, folders) {
            return folders.filter(isSame(folder)).length > 0;
        }

        function getFolderToSelect(folders) {
            return folderService.current()
                .then(function(currentFolder) {
                    return folderExistsIn(currentFolder, folders) ?
                        currentFolder :
                        firstIfExist(folders);
                }, function(error) {
                    return firstIfExist(folders);
                });
        }

        function setFolders(folders) {
            $scope.folders = folders;
            return getFolderToSelect(folders).then(select);
        }

        function listFolders() {
            return folderService.list()
                .then(folderService.orderByName)
                .then(setFolders);
        }

        function createNew() {
            var folderName = $translate.instant('COMPONENT.FOLDER.UNTITLED_FOLDER');

            while (folderNameExists(folderName)) {
                if (/\d$/.test(folderName)) {
                    folderName = folderName.replace(/\d$/, parseInt(folderName.slice(-1), 10) + 1);
                } else {
                    folderName = folderName + ' 2';
                }
            }
            return folderService.createNew(folderName)
                .then(function(newFolder) {
                    return listFolders()
                        .then(function() {
                            $scope.$broadcast(EVENTS.FOLDER.FOCUS, newFolder);
                        });
                });

        }

        function deleteSelectedFolder() {
            return confirmationService
                .confirm($translate.instant('NOTIFICATION.FOLDER.DELETE_FOLDER_TITLE'),
                    $translate.instant('NOTIFICATION.DELETE.CONFIRMATION'),
                    $translate.instant('NOTIFICATION.DELETE.CONFIRM'),
                    $translate.instant('NOTIFICATION.DELETE.CANCEL'))
                .then(function() {
                    return folderService.deleteFolder($scope.selected)
                        .then(listFolders);
                });
        }

        function captureDropped(folder, capture) {
            $scope.$emit(EVENTS.FOLDER.CAPTURE.DROPPED, {
                capture: capture,
                folder: folder
            });
        }

        $scope.$on(EVENTS.FOLDER.UPDATED, function(evt, newFolder) {
            listFolders().then(function() {
                $scope.$broadcast(EVENTS.FOLDER.FOCUS, newFolder);
            });

        });

        $scope.onDropped = captureDropped;
        $scope.select = select;
        $scope.createNew = createNew;
        $scope.deleteSelectedFolder = deleteSelectedFolder;

        listFolders();

    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/folders/folders.controller.js
// module id = 455
// module chunks = 0